import React from "react";

const SwitchOn = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="36" viewBox="0 0 34 36" fill="none">
      <g filter="url(#filter0_i_2059_2039)">
        <rect y="6" width="40" height="20" rx="10" fill="#FC4C4C" />
      </g>
      <g filter="url(#filter1_d_2059_2039)">
        <circle cx="32" cy="16" r="8" fill="url(#paint0_linear_2059_2039)" />
        <circle cx="32" cy="16" r="7.5" stroke="url(#paint1_linear_2059_2039)" />
      </g>
      <defs>
        <filter
          id="filter0_i_2059_2039"
          x="0"
          y="5"
          width="40"
          height="21"
          filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.945833 0 0 0 0 0.717257 0 0 0 0 0.717257 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2059_2039" />
        </filter>
        <filter
          id="filter1_d_2059_2039"
          x="14"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_2039" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2059_2039"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2059_2039"
          x1="25.6"
          y1="17.2"
          x2="45.2"
          y2="29.6"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="#E5E7E8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2059_2039"
          x1="21.2"
          y1="5.6"
          x2="38.8"
          y2="23.2"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const SwitchDisabled = () => {
  return (
    <svg width="50" height="36" viewBox="0 0 50 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_2059_2058)">
        <rect x="10" y="6" width="40" height="20" rx="10" fill="#9CA3A8" />
      </g>
      <g filter="url(#filter1_d_2059_2058)">
        <circle cx="18" cy="16" r="8" fill="url(#paint0_linear_2059_2058)" />
        <circle cx="18" cy="16" r="7.5" stroke="url(#paint1_linear_2059_2058)" />
      </g>
      <defs>
        <filter
          id="filter0_i_2059_2058"
          x="10"
          y="5"
          width="40"
          height="21"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.576771 0 0 0 0 0.597613 0 0 0 0 0.6125 0 0 0 0.86 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2059_2058" />
        </filter>
        <filter
          id="filter1_d_2059_2058"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_2058" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2059_2058"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2059_2058"
          x1="11.6"
          y1="17.2"
          x2="31.2"
          y2="29.6"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="#E5E7E8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2059_2058"
          x1="7.2"
          y1="5.6"
          x2="24.8"
          y2="23.2"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const SwitchOff = () => {
  return (
    <svg width="50" height="36" viewBox="0 0 50 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_2059_2072)">
        <rect x="10" y="6" width="40" height="20" rx="10" fill="#E5E7E8" />
      </g>
      <g filter="url(#filter1_d_2059_2072)">
        <circle cx="18" cy="16" r="8" fill="url(#paint0_linear_2059_2072)" />
        <circle cx="18" cy="16" r="7.5" stroke="url(#paint1_linear_2059_2072)" />
      </g>
      <defs>
        <filter
          id="filter0_i_2059_2072"
          x="10"
          y="5"
          width="40"
          height="21"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.855833 0 0 0 0 0.863056 0 0 0 0 0.866667 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2059_2072" />
        </filter>
        <filter
          id="filter1_d_2059_2072"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2059_2072" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2059_2072"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2059_2072"
          x1="11.6"
          y1="17.2"
          x2="31.2"
          y2="29.6"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="#E5E7E8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2059_2072"
          x1="7.2"
          y1="5.6"
          x2="24.8"
          y2="23.2"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DcaSwitch = ({ stage }: { stage: "on" | "off" | "disabled" }) => {
  // return the correct switch depending ont the stage
  if (stage === "on") return <SwitchOn />;
  if (stage === "off") return <SwitchOff />;
  if (stage === "disabled") return <SwitchDisabled />;
  return <></>;
};
